export class PasswordUtils {
    public static validate = (password: string): boolean => {
        const isPasswordValid = password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d-!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~]{8,32}$/);
        return !!isPasswordValid;
    }
}